<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App"
};
</script>

<style lang="sass">
@import "./assets/scss/common.scss"
#app
  min-height: 100vh
  display: flex
  flex-direction: column
</style>
